export default {
  fallbackLocale: ["en", "en-legal"],
};